export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Upload: { input: any; output: any; }
  Uuid: { input: any; output: any; }
};

export type AddProductTechMapPaginated = {
  __typename?: 'AddProductTechMapPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<ProductProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BookingAllowedDurationProxy = {
  __typename?: 'BookingAllowedDurationProxy';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BookingHistoryDataProxy = {
  __typename?: 'BookingHistoryDataProxy';
  bookingHistory?: Maybe<BookingHistoryProxy>;
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type BookingHistoryProxy = {
  __typename?: 'BookingHistoryProxy';
  booking?: Maybe<BookingMainProxy>;
  bookingHistoryData?: Maybe<Array<BookingHistoryDataProxy>>;
  changeTime?: Maybe<Scalars['String']['output']>;
  client?: Maybe<ClientProxy>;
  exists: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  user?: Maybe<UserProxy>;
};


export type BookingHistoryProxyChangeTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type BookingMainProxy = {
  __typename?: 'BookingMainProxy';
  bookingHistories?: Maybe<Array<BookingHistoryProxy>>;
  bookingSalary?: Maybe<BookingSalaryProxy>;
  branch?: Maybe<BranchProxy>;
  client?: Maybe<ClientProxy>;
  date?: Maybe<Scalars['String']['output']>;
  durationMoreThenGap?: Maybe<Scalars['Boolean']['output']>;
  employee?: Maybe<EmployeeProxy>;
  endTime?: Maybe<Scalars['String']['output']>;
  fromOnline?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isWriteOffCompleted: Scalars['Boolean']['output'];
  needClientRecall: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  notificationTime?: Maybe<Scalars['String']['output']>;
  operationNumberForWriteOff?: Maybe<Scalars['Uuid']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  review?: Maybe<ReviewProxy>;
  salaryPayments?: Maybe<SalaryPaymentPaginated>;
  saleActionDate?: Maybe<Scalars['String']['output']>;
  saleActionProductsAmount?: Maybe<Scalars['Int']['output']>;
  service?: Maybe<ServiceProxy>;
  status?: Maybe<BookingStatusProxy>;
  technologicalMaps?: Maybe<Array<TechnologicalMapProxy>>;
  time?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['Uuid']['output'];
};


export type BookingMainProxyBookingHistoriesArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BookingMainProxyDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMainProxyEndTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMainProxySalaryPaymentsArgs = {
  branchId: Scalars['Int']['input'];
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMainProxySaleActionDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMainProxyTechnologicalMapsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  inStockProducts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BookingMainProxyTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type BookingModuleConfigProxy = {
  __typename?: 'BookingModuleConfigProxy';
  allowedDuration?: Maybe<BookingAllowedDurationProxy>;
  company?: Maybe<CompanyProxy>;
  confirmationCall: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  onlineBooking: Scalars['Boolean']['output'];
};

export type BookingPaginated = {
  __typename?: 'BookingPaginated';
  bookings?: Maybe<Array<BookingMainProxy>>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BookingProxy = {
  __typename?: 'BookingProxy';
  branch: BranchProxy;
  client: Client;
  date: Scalars['String']['output'];
  employee: EmployeeBookingProxy;
  endTime: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  notificationTime?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  service: ServiceBookingProxy;
  status: Scalars['String']['output'];
  time: Scalars['String']['output'];
  uuid: Scalars['Uuid']['output'];
};


export type BookingProxyDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingProxyEndTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingProxyNotificationTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingProxyTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type BookingSalaryProxy = {
  __typename?: 'BookingSalaryProxy';
  booking?: Maybe<BookingProxy>;
  id: Scalars['Int']['output'];
  salaryType?: Maybe<Scalars['Int']['output']>;
  salaryValue?: Maybe<Scalars['Float']['output']>;
};

export type BookingStatusProxy = {
  __typename?: 'BookingStatusProxy';
  bookings?: Maybe<BookingPaginated>;
  colorCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type BookingStatusProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};

export type BookingTime = {
  __typename?: 'BookingTime';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};


export type BookingTimeEndArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingTimeStartArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type Branch = {
  __typename?: 'Branch';
  address: Scalars['String']['output'];
  city?: Maybe<City>;
  closestBookingDate?: Maybe<Scalars['String']['output']>;
  closestBookingDateDefaultEmployee?: Maybe<Scalars['String']['output']>;
  closestBookingTimes?: Maybe<Array<BookingTime>>;
  closestBookingTimesDefaultEmployee?: Maybe<Array<BookingTime>>;
  country: Country;
  currencyCode: Scalars['String']['output'];
  dateTimeFormat?: Maybe<DateTimeFormat>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Language>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  phoneCode?: Maybe<Scalars['String']['output']>;
  serviceImages: Array<Scalars['String']['output']>;
  website: Scalars['String']['output'];
  workSchedule?: Maybe<Scalars['String']['output']>;
};


export type BranchClosestBookingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BranchClosestBookingDateDefaultEmployeeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type BranchDetailsProxy = {
  __typename?: 'BranchDetailsProxy';
  branch: BranchProxy;
  formatedAddress?: Maybe<Scalars['String']['output']>;
  googleMapUri?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  maxPrice?: Maybe<Scalars['Int']['output']>;
  minPrice?: Maybe<Scalars['Int']['output']>;
  priceLevel?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  utcOffsetMinutes: Scalars['Int']['output'];
};

export type BranchPaginated = {
  __typename?: 'BranchPaginated';
  branches?: Maybe<Array<BranchProxy>>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  isCanCreateNewBranch: Scalars['Boolean']['output'];
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BranchPhoneProxy = {
  __typename?: 'BranchPhoneProxy';
  branch: BranchProxy;
  id: Scalars['Int']['output'];
  phone: Scalars['String']['output'];
};

export type BranchProxy = {
  __typename?: 'BranchProxy';
  activeDeliveryMenu?: Maybe<MenuProxy>;
  activeDineInMenu?: Maybe<MenuProxy>;
  activePickUpMenu?: Maybe<MenuProxy>;
  address: Scalars['String']['output'];
  bookingQrCode: Scalars['String']['output'];
  bookingQrLink: Scalars['String']['output'];
  bookings?: Maybe<BookingPaginated>;
  bookingsList?: Maybe<Array<BookingMainProxy>>;
  branchDetails?: Maybe<BranchDetailsProxy>;
  branchEmployees?: Maybe<Array<EmployeeProxy>>;
  branchImages?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<CompanyTypeProxy>;
  city?: Maybe<CityProxy>;
  closestBookingDate?: Maybe<Scalars['String']['output']>;
  closestBookingDateDefaultEmployee?: Maybe<Scalars['String']['output']>;
  closestBookingTimes?: Maybe<Array<BookingTime>>;
  closestBookingTimesDefaultEmployee?: Maybe<Array<BookingTime>>;
  company?: Maybe<CompanyProxy>;
  country: Country;
  countryProxy?: Maybe<CountryProxy>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currencyCode: Scalars['String']['output'];
  customDays?: Maybe<Array<CustomDayProxy>>;
  dateTimeFormat?: Maybe<DateTimeFormatProxy>;
  deleted: Scalars['Boolean']['output'];
  deliveryWorkSchedules?: Maybe<Array<BranchWorkScheduleProxy>>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeWorkScheduleSetting?: Maybe<EmployeeWorkScheduleSetting>;
  employees?: Maybe<Array<EmployeeProxy>>;
  employeesPaginated?: Maybe<EmployeePaginated>;
  generalWorkSchedules?: Maybe<Array<BranchWorkScheduleProxy>>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isAnyActiveServiceEmployeeRelations: Scalars['Boolean']['output'];
  isAnyActiveServices: Scalars['Boolean']['output'];
  isAnyEmployeeWithOnlineBookingOn: Scalars['Boolean']['output'];
  isAnyWorkScheduleForWorkingEmployees: Scalars['Boolean']['output'];
  kitchenWorkSchedules?: Maybe<Array<BranchWorkScheduleProxy>>;
  language?: Maybe<LanguageProxy>;
  logbookSetting?: Maybe<LogbookSetting>;
  meBookingConfig?: Maybe<MeBookingBranchConfigProxy>;
  menus?: Maybe<MenuPaginated>;
  menusList?: Maybe<Array<MenuProxy>>;
  name: Scalars['String']['output'];
  onlineRegistration: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  phoneCode?: Maybe<Scalars['String']['output']>;
  phones?: Maybe<Array<BranchPhoneProxy>>;
  rating?: Maybe<Scalars['Int']['output']>;
  removedOfTariff: Scalars['Boolean']['output'];
  replaceableDeliveryMenus?: Maybe<Array<MenuProxy>>;
  replaceableDineInMenus?: Maybe<Array<MenuProxy>>;
  replaceablePickUpMenus?: Maybe<Array<MenuProxy>>;
  serviceImages?: Maybe<Array<Scalars['String']['output']>>;
  socialLink?: Maybe<BranchSocialLinkProxy>;
  storageProductRelationHistoryList?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  storageProductRelationHistoryPaginated?: Maybe<StorageProductRelationHistoryPaginatedType>;
  storages?: Maybe<Array<StorageProxy>>;
  storagesPaginated?: Maybe<StoragePaginated>;
  suppliers?: Maybe<Array<SupplierProxy>>;
  timeZone: Scalars['String']['output'];
  type?: Maybe<BranchTypeProxy>;
  userBranchRelations?: Maybe<Array<UserBranchRelationProxy>>;
  website?: Maybe<Scalars['String']['output']>;
  workSchedule?: Maybe<Scalars['String']['output']>;
  workSchedules?: Maybe<Array<WorkScheduleProxy>>;
};


export type BranchProxyBookingsArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['Uuid']['input']>;
};


export type BranchProxyBookingsListArgs = {
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['Uuid']['input']>;
};


export type BranchProxyClosestBookingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProxyClosestBookingDateDefaultEmployeeArgs = {
  format: Scalars['String']['input'];
};


export type BranchProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProxyCustomDaysArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyDeliveryWorkSchedulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyEmployeesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BranchProxyEmployeesPaginatedArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filterByNameAndPosition?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  positionId?: InputMaybe<Scalars['Int']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyGeneralWorkSchedulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyKitchenWorkSchedulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyMenusArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  menuTypeId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProxyMenusListArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  menuTypeId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProxyPhonesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyStorageProductRelationHistoryListArgs = {
  operationNumber?: InputMaybe<Scalars['Uuid']['input']>;
};


export type BranchProxyStorageProductRelationHistoryPaginatedArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  bookingUuid?: InputMaybe<Scalars['Uuid']['input']>;
  edited?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  operationNumber?: InputMaybe<Scalars['Uuid']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productCategory?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  remnants?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storageId?: InputMaybe<Scalars['Int']['input']>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyStoragesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyStoragesPaginatedArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxySuppliersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyUserBranchRelationsArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyWorkSchedulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BranchSocialLinkProxy = {
  __typename?: 'BranchSocialLinkProxy';
  branch: BranchProxy;
  facebook?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  whatsapp?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type BranchTypeProxy = {
  __typename?: 'BranchTypeProxy';
  branches?: Maybe<Array<BranchProxy>>;
  childTypes?: Maybe<Array<Maybe<BranchTypeProxy>>>;
  company?: Maybe<CompanyProxy>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentType?: Maybe<BranchTypeProxy>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type BranchTypeProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchTypeProxyChildTypesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BranchWorkPeriodTypeProxy = {
  __typename?: 'BranchWorkPeriodTypeProxy';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  workSchedules?: Maybe<Array<BranchWorkScheduleProxy>>;
};


export type BranchWorkPeriodTypeProxyWorkSchedulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BranchWorkScheduleProxy = {
  __typename?: 'BranchWorkScheduleProxy';
  branch: BranchProxy;
  day: DayProxy;
  id: Scalars['Int']['output'];
  period: Scalars['String']['output'];
  type: BranchWorkPeriodTypeProxy;
};

export type City = {
  __typename?: 'City';
  country: Country;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CityProxy = {
  __typename?: 'CityProxy';
  country?: Maybe<CountryProxy>;
  custom?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Client = {
  __typename?: 'Client';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  patronymic?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneCode?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type ClientPaginated = {
  __typename?: 'ClientPaginated';
  clients?: Maybe<Array<ClientProxy>>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ClientProxy = {
  __typename?: 'ClientProxy';
  bookingHistories?: Maybe<Array<BookingHistoryProxy>>;
  bookings?: Maybe<BookingPaginated>;
  category?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyProxy>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<GenderProxy>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  loyaltyCard?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patronymic?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};


export type ClientProxyBookingHistoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ClientProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type ClientProxyDateOfBirthArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ClientQueryInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClientReservationInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  surname?: InputMaybe<Scalars['String']['input']>;
};

export enum CompanyAccess {
  AccessManageBranchEmployees = 'ACCESS_MANAGE_BRANCH_EMPLOYEES',
  AccessManageCompanyEmployees = 'ACCESS_MANAGE_COMPANY_EMPLOYEES',
  AccessSettingsView = 'ACCESS_SETTINGS_VIEW',
  AdminViewBranch = 'ADMIN_VIEW_BRANCH',
  BookingStatisticViewExport = 'BOOKING_STATISTIC_VIEW_EXPORT',
  BranchCreate = 'BRANCH_CREATE',
  BranchDeleteRestore = 'BRANCH_DELETE_RESTORE',
  BranchEdit = 'BRANCH_EDIT',
  BranchView = 'BRANCH_VIEW',
  CancelBooking = 'CANCEL_BOOKING',
  CheckAllSchedule = 'CHECK_ALL_SCHEDULE',
  ClientsHideContacts = 'CLIENTS_HIDE_CONTACTS',
  ClientsShowContacts = 'CLIENTS_SHOW_CONTACTS',
  ClientCreate = 'CLIENT_CREATE',
  ClientDelete = 'CLIENT_DELETE',
  ClientEdit = 'CLIENT_EDIT',
  ClientExport = 'CLIENT_EXPORT',
  ClientImport = 'CLIENT_IMPORT',
  ClientListView = 'CLIENT_LIST_VIEW',
  CompanyDeleteRestore = 'COMPANY_DELETE_RESTORE',
  CompanyInfoEdit = 'COMPANY_INFO_EDIT',
  CompanyInfoView = 'COMPANY_INFO_VIEW',
  CreateBooking = 'CREATE_BOOKING',
  CreateBranch = 'CREATE_BRANCH',
  CreateClient = 'CREATE_CLIENT',
  CreateEmployee = 'CREATE_EMPLOYEE',
  CreatePosition = 'CREATE_POSITION',
  CreateProduct = 'CREATE_PRODUCT',
  CreateProductCategory = 'CREATE_PRODUCT_CATEGORY',
  CreateReview = 'CREATE_REVIEW',
  CreateService = 'CREATE_SERVICE',
  CreateServiceCategory = 'CREATE_SERVICE_CATEGORY',
  CreateStorage = 'CREATE_STORAGE',
  CreateTechnologicalMap = 'CREATE_TECHNOLOGICAL_MAP',
  CreateTechnologicalMapCategory = 'CREATE_TECHNOLOGICAL_MAP_CATEGORY',
  CustomDayCreate = 'CUSTOM_DAY_CREATE',
  CustomDayDelete = 'CUSTOM_DAY_DELETE',
  CustomDayEdit = 'CUSTOM_DAY_EDIT',
  DeleteBranch = 'DELETE_BRANCH',
  DeleteClient = 'DELETE_CLIENT',
  DeleteCompany = 'DELETE_COMPANY',
  DeletePosition = 'DELETE_POSITION',
  DeleteProduct = 'DELETE_PRODUCT',
  DeleteReview = 'DELETE_REVIEW',
  DeleteTechnologicalMap = 'DELETE_TECHNOLOGICAL_MAP',
  DismissEmployee = 'DISMISS_EMPLOYEE',
  EditBooking = 'EDIT_BOOKING',
  EditBranch = 'EDIT_BRANCH',
  EditClient = 'EDIT_CLIENT',
  EditCompany = 'EDIT_COMPANY',
  EditEmployee = 'EDIT_EMPLOYEE',
  EditPosition = 'EDIT_POSITION',
  EditProduct = 'EDIT_PRODUCT',
  EditProductCategory = 'EDIT_PRODUCT_CATEGORY',
  EditReview = 'EDIT_REVIEW',
  EditSalary = 'EDIT_SALARY',
  EditSchedule = 'EDIT_SCHEDULE',
  EditService = 'EDIT_SERVICE',
  EditServiceCategory = 'EDIT_SERVICE_CATEGORY',
  EditStorage = 'EDIT_STORAGE',
  EditTechnologicalMap = 'EDIT_TECHNOLOGICAL_MAP',
  EditTechnologicalMapCategory = 'EDIT_TECHNOLOGICAL_MAP_CATEGORY',
  EmailBookingCancel = 'EMAIL_BOOKING_CANCEL',
  EmailBookingCreate = 'EMAIL_BOOKING_CREATE',
  EmailBookingEdit = 'EMAIL_BOOKING_EDIT',
  EmailCompanyOrBranchOrOnlineSettingsEdit = 'EMAIL_COMPANY_OR_BRANCH_OR_ONLINE_SETTINGS_EDIT',
  EmailCriticalStock = 'EMAIL_CRITICAL_STOCK',
  EmailReviewWasLeft = 'EMAIL_REVIEW_WAS_LEFT',
  EmailScheduleExpiresSoon = 'EMAIL_SCHEDULE_EXPIRES_SOON',
  EmailSubscriptionExpired = 'EMAIL_SUBSCRIPTION_EXPIRED',
  EmailSubscriptionExpiresSoon = 'EMAIL_SUBSCRIPTION_EXPIRES_SOON',
  EmployeeBookingSettingsEdit = 'EMPLOYEE_BOOKING_SETTINGS_EDIT',
  EmployeeBookingSettingsView = 'EMPLOYEE_BOOKING_SETTINGS_VIEW',
  EmployeeCreate = 'EMPLOYEE_CREATE',
  EmployeeDismiss = 'EMPLOYEE_DISMISS',
  EmployeeEdit = 'EMPLOYEE_EDIT',
  EmployeeEditSelf = 'EMPLOYEE_EDIT_SELF',
  EmployeeExport = 'EMPLOYEE_EXPORT',
  EmployeeImport = 'EMPLOYEE_IMPORT',
  EmployeeListView = 'EMPLOYEE_LIST_VIEW',
  EmployeeServicesEdit = 'EMPLOYEE_SERVICES_EDIT',
  EmployeeServicesView = 'EMPLOYEE_SERVICES_VIEW',
  EmployeeView = 'EMPLOYEE_VIEW',
  EmployeeViewBranch = 'EMPLOYEE_VIEW_BRANCH',
  EmployeeViewClient = 'EMPLOYEE_VIEW_CLIENT',
  EmployeeViewPosition = 'EMPLOYEE_VIEW_POSITION',
  EmployeeViewProduct = 'EMPLOYEE_VIEW_PRODUCT',
  EmployeeViewProductCategory = 'EMPLOYEE_VIEW_PRODUCT_CATEGORY',
  EmployeeViewSelf = 'EMPLOYEE_VIEW_SELF',
  EmployeeViewService = 'EMPLOYEE_VIEW_SERVICE',
  EmployeeViewServiceCategory = 'EMPLOYEE_VIEW_SERVICE_CATEGORY',
  EmployeeViewStorage = 'EMPLOYEE_VIEW_STORAGE',
  EmployeeViewTechnologicalMap = 'EMPLOYEE_VIEW_TECHNOLOGICAL_MAP',
  EmployeeViewTechnologicalMapCategory = 'EMPLOYEE_VIEW_TECHNOLOGICAL_MAP_CATEGORY',
  LogbookBookingCreate = 'LOGBOOK_BOOKING_CREATE',
  LogbookBookingEdit = 'LOGBOOK_BOOKING_EDIT',
  LogbookBookingStatusEdit = 'LOGBOOK_BOOKING_STATUS_EDIT',
  LogbookConsumablesWriteOff = 'LOGBOOK_CONSUMABLES_WRITE_OFF',
  LogbookHistoryView = 'LOGBOOK_HISTORY_VIEW',
  LogbookPopoverBookingStatusEdit = 'LOGBOOK_POPOVER_BOOKING_STATUS_EDIT',
  LogbookSettingsEdit = 'LOGBOOK_SETTINGS_EDIT',
  LogbookView = 'LOGBOOK_VIEW',
  MenuCloneEdit = 'MENU_CLONE_EDIT',
  MenuCreate = 'MENU_CREATE',
  MenuDeleteRestore = 'MENU_DELETE_RESTORE',
  MenuDishCategoryCreate = 'MENU_DISH_CATEGORY_CREATE',
  MenuDishCategoryDeleteRestore = 'MENU_DISH_CATEGORY_DELETE_RESTORE',
  MenuDishCategoryEdit = 'MENU_DISH_CATEGORY_EDIT',
  MenuDishCategoryExport = 'MENU_DISH_CATEGORY_EXPORT',
  MenuDishCategoryImport = 'MENU_DISH_CATEGORY_IMPORT',
  MenuDishCategoryListView = 'MENU_DISH_CATEGORY_LIST_VIEW',
  MenuDishClone = 'MENU_DISH_CLONE',
  MenuDishCreate = 'MENU_DISH_CREATE',
  MenuDishDeleteRestore = 'MENU_DISH_DELETE_RESTORE',
  MenuDishEdit = 'MENU_DISH_EDIT',
  MenuDishListView = 'MENU_DISH_LIST_VIEW',
  MenuListView = 'MENU_LIST_VIEW',
  MenuOptionsAndSupplementsCreate = 'MENU_OPTIONS_AND_SUPPLEMENTS_CREATE',
  MenuOptionsAndSupplementsDeleteRestore = 'MENU_OPTIONS_AND_SUPPLEMENTS_DELETE_RESTORE',
  MenuOptionsAndSupplementsEdit = 'MENU_OPTIONS_AND_SUPPLEMENTS_EDIT',
  MenuOptionsAndSupplementsListView = 'MENU_OPTIONS_AND_SUPPLEMENTS_LIST_VIEW',
  OnlineBookingSettingsEdit = 'ONLINE_BOOKING_SETTINGS_EDIT',
  OnlineBookingSettingsView = 'ONLINE_BOOKING_SETTINGS_VIEW',
  Payment = 'PAYMENT',
  PaymentsHistoryView = 'PAYMENTS_HISTORY_VIEW',
  PaymentCreate = 'PAYMENT_CREATE',
  PaymentDelete = 'PAYMENT_DELETE',
  PaymentEdit = 'PAYMENT_EDIT',
  PositionCreate = 'POSITION_CREATE',
  PositionDelete = 'POSITION_DELETE',
  PositionEdit = 'POSITION_EDIT',
  PositionListView = 'POSITION_LIST_VIEW',
  ProductCategoryCreate = 'PRODUCT_CATEGORY_CREATE',
  ProductCategoryDeleteRestore = 'PRODUCT_CATEGORY_DELETE_RESTORE',
  ProductCategoryEdit = 'PRODUCT_CATEGORY_EDIT',
  ProductCategoryExport = 'PRODUCT_CATEGORY_EXPORT',
  ProductCategoryImport = 'PRODUCT_CATEGORY_IMPORT',
  ProductCategoryListView = 'PRODUCT_CATEGORY_LIST_VIEW',
  ProductCreate = 'PRODUCT_CREATE',
  ProductDeleteRestore = 'PRODUCT_DELETE_RESTORE',
  ProductEdit = 'PRODUCT_EDIT',
  ProductExport = 'PRODUCT_EXPORT',
  ProductImport = 'PRODUCT_IMPORT',
  ProductListView = 'PRODUCT_LIST_VIEW',
  RestoreBranch = 'RESTORE_BRANCH',
  ReviewCreate = 'REVIEW_CREATE',
  ReviewDelete = 'REVIEW_DELETE',
  ReviewEdit = 'REVIEW_EDIT',
  ReviewListView = 'REVIEW_LIST_VIEW',
  RoleClone = 'ROLE_CLONE',
  RoleCreateClone = 'ROLE_CREATE_CLONE',
  RoleDelete = 'ROLE_DELETE',
  RoleEdit = 'ROLE_EDIT',
  SalarySettingsEdit = 'SALARY_SETTINGS_EDIT',
  SalarySettingsView = 'SALARY_SETTINGS_VIEW',
  SalaryView = 'SALARY_VIEW',
  ScheduleCalendarView = 'SCHEDULE_CALENDAR_VIEW',
  ScheduleCreate = 'SCHEDULE_CREATE',
  ScheduleDelete = 'SCHEDULE_DELETE',
  ScheduleEdit = 'SCHEDULE_EDIT',
  SelfCheckSchedule = 'SELF_CHECK_SCHEDULE',
  SelfEditSchedule = 'SELF_EDIT_SCHEDULE',
  ServiceAndOnlineBookingEdit = 'SERVICE_AND_ONLINE_BOOKING_EDIT',
  ServiceCategoryCreate = 'SERVICE_CATEGORY_CREATE',
  ServiceCategoryDeleteRestore = 'SERVICE_CATEGORY_DELETE_RESTORE',
  ServiceCategoryEdit = 'SERVICE_CATEGORY_EDIT',
  ServiceCategoryExport = 'SERVICE_CATEGORY_EXPORT',
  ServiceCategoryImport = 'SERVICE_CATEGORY_IMPORT',
  ServiceCategoryListView = 'SERVICE_CATEGORY_LIST_VIEW',
  ServiceCreate = 'SERVICE_CREATE',
  ServiceDeleteRestore = 'SERVICE_DELETE_RESTORE',
  ServiceEmployeesEdit = 'SERVICE_EMPLOYEES_EDIT',
  ServiceEmployeesView = 'SERVICE_EMPLOYEES_VIEW',
  ServiceExport = 'SERVICE_EXPORT',
  ServiceImport = 'SERVICE_IMPORT',
  ServiceListView = 'SERVICE_LIST_VIEW',
  ServiceTechMapsEdit = 'SERVICE_TECH_MAPS_EDIT',
  ServiceTechMapsView = 'SERVICE_TECH_MAPS_VIEW',
  StorageOperations = 'STORAGE_OPERATIONS',
  StorageReport = 'STORAGE_REPORT',
  TariffModulesManage = 'TARIFF_MODULES_MANAGE',
  TariffSubscriptionManage = 'TARIFF_SUBSCRIPTION_MANAGE',
  TariffView = 'TARIFF_VIEW',
  TechMapCategoryCreate = 'TECH_MAP_CATEGORY_CREATE',
  TechMapCategoryDeleteRestore = 'TECH_MAP_CATEGORY_DELETE_RESTORE',
  TechMapCategoryEdit = 'TECH_MAP_CATEGORY_EDIT',
  TechMapCategoryExport = 'TECH_MAP_CATEGORY_EXPORT',
  TechMapCategoryImport = 'TECH_MAP_CATEGORY_IMPORT',
  TechMapCategoryListView = 'TECH_MAP_CATEGORY_LIST_VIEW',
  TechMapCreate = 'TECH_MAP_CREATE',
  TechMapDeleteRestore = 'TECH_MAP_DELETE_RESTORE',
  TechMapEdit = 'TECH_MAP_EDIT',
  TechMapListView = 'TECH_MAP_LIST_VIEW',
  TechMapProductListEdit = 'TECH_MAP_PRODUCT_LIST_EDIT',
  TechMapProductListView = 'TECH_MAP_PRODUCT_LIST_VIEW',
  TechMapServiceListEdit = 'TECH_MAP_SERVICE_LIST_EDIT',
  TechMapServiceListView = 'TECH_MAP_SERVICE_LIST_VIEW',
  VacationCreate = 'VACATION_CREATE',
  VacationDelete = 'VACATION_DELETE',
  VacationEdit = 'VACATION_EDIT',
  ViewCompany = 'VIEW_COMPANY',
  ViewEmployee = 'VIEW_EMPLOYEE',
  WarehouseCreate = 'WAREHOUSE_CREATE',
  WarehouseDeleteRestore = 'WAREHOUSE_DELETE_RESTORE',
  WarehouseEdit = 'WAREHOUSE_EDIT',
  WarehouseListView = 'WAREHOUSE_LIST_VIEW',
  WarehouseOperationArrivalEdit = 'WAREHOUSE_OPERATION_ARRIVAL_EDIT',
  WarehouseOperationConsumablesWriteOffEdit = 'WAREHOUSE_OPERATION_CONSUMABLES_WRITE_OFF_EDIT',
  WarehouseOperationEditHistoryView = 'WAREHOUSE_OPERATION_EDIT_HISTORY_VIEW',
  WarehouseOperationListView = 'WAREHOUSE_OPERATION_LIST_VIEW',
  WarehouseOperationMoveEdit = 'WAREHOUSE_OPERATION_MOVE_EDIT',
  WarehouseOperationProductWriteOffEdit = 'WAREHOUSE_OPERATION_PRODUCT_WRITE_OFF_EDIT',
  WarehouseOperationSaleCreate = 'WAREHOUSE_OPERATION_SALE_CREATE',
  WarehouseOperationSaleEdit = 'WAREHOUSE_OPERATION_SALE_EDIT',
  WarehouseProductAdd = 'WAREHOUSE_PRODUCT_ADD',
  WarehouseProductArrival = 'WAREHOUSE_PRODUCT_ARRIVAL',
  WarehouseProductCreateAndAdd = 'WAREHOUSE_PRODUCT_CREATE_AND_ADD',
  WarehouseProductDelete = 'WAREHOUSE_PRODUCT_DELETE',
  WarehouseProductListView = 'WAREHOUSE_PRODUCT_LIST_VIEW',
  WarehouseProductMove = 'WAREHOUSE_PRODUCT_MOVE',
  WarehouseProductWriteOff = 'WAREHOUSE_PRODUCT_WRITE_OFF',
  WarehouseReportViewExport = 'WAREHOUSE_REPORT_VIEW_EXPORT'
}

export type CompanyAccessProxy = {
  __typename?: 'CompanyAccessProxy';
  action?: Maybe<CompanyAccess>;
  id: Scalars['Int']['output'];
  role?: Maybe<RoleProxy>;
  scope?: Maybe<PermissionScope>;
};

export type CompanyProxy = {
  __typename?: 'CompanyProxy';
  address: Scalars['String']['output'];
  bookingQrLink: Scalars['String']['output'];
  bookings?: Maybe<BookingPaginated>;
  branchTypes?: Maybe<Array<BranchTypeProxy>>;
  branches?: Maybe<Array<BranchProxy>>;
  branchesPaginated?: Maybe<BranchPaginated>;
  category?: Maybe<CompanyTypeProxy>;
  city?: Maybe<CityProxy>;
  clients?: Maybe<ClientPaginated>;
  country?: Maybe<CountryProxy>;
  currency?: Maybe<CurrencyProxy>;
  dateTimeFormat?: Maybe<DateTimeFormatProxy>;
  deleted: Scalars['Boolean']['output'];
  employeePositions?: Maybe<EmployeePositionPaginated>;
  employees?: Maybe<EmployeePaginated>;
  employeesList?: Maybe<Array<EmployeeProxy>>;
  employeesNotInBranch?: Maybe<Array<EmployeeProxy>>;
  expiredPaidFeatures?: Maybe<Array<PaidFeatureProxy>>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isPremiumOn: Scalars['Boolean']['output'];
  language?: Maybe<LanguageProxy>;
  languages?: Maybe<Array<LanguageProxy>>;
  loggedInUser?: Maybe<EmployeeProxy>;
  meBookingModuleConfig?: Maybe<BookingModuleConfigProxy>;
  meBookingSyncStatus?: Maybe<Scalars['Int']['output']>;
  meMenuCategories?: Maybe<Array<MenuCategoryProxy>>;
  meMenuCategoriesPaginated?: Maybe<MenuCategoryPaginated>;
  menuCategoryIconList?: Maybe<Array<MenuCategoryIconProxy>>;
  menuItems?: Maybe<MenuItemPaginated>;
  menuItemsList?: Maybe<Array<Maybe<MenuItemProxy>>>;
  menuSupplements?: Maybe<MenuSupplementPaginated>;
  menuSupplementsList?: Maybe<Array<MenuSupplementProxy>>;
  messageLanguage?: Maybe<LanguageProxy>;
  modules?: Maybe<Array<ModuleProxy>>;
  name: Scalars['String']['output'];
  ownerPosition?: Maybe<EmployeePositionProxy>;
  paidFeatures?: Maybe<Array<PaidFeatureProxy>>;
  paidFeaturesPaginated: PaidFeaturePaginated;
  paymentOrders?: Maybe<Array<PaymentOrderProxy>>;
  phone: Scalars['String']['output'];
  primaryLanguage?: Maybe<LanguageProxy>;
  productCategories?: Maybe<Array<ProductCategoryNewProxy>>;
  products?: Maybe<Array<ProductProxy>>;
  productsList?: Maybe<ProductPaginated>;
  reviews?: Maybe<ReviewPaginated>;
  salaryPayments?: Maybe<SalaryPaymentPaginated>;
  serviceCategoriesNew?: Maybe<Array<ServiceCategoryNewProxy>>;
  services?: Maybe<ServicePaginated>;
  servicesList?: Maybe<Array<ServiceProxy>>;
  servicesListForTechMap?: Maybe<ServicePaginated>;
  suppliers?: Maybe<Array<SupplierProxy>>;
  techMapListForServices?: Maybe<TechnologicalMapPaginated>;
  technologicalMapCategories?: Maybe<Array<TechnologicalMapCategoryProxy>>;
  technologicalMapCategoriesNew?: Maybe<Array<TechMapCategoryNewProxy>>;
  technologicalMaps?: Maybe<TechnologicalMapPaginated>;
  technologicalMapsList?: Maybe<Array<TechnologicalMapProxy>>;
  timeZone?: Maybe<TimeZoneProxy>;
  userCompanyRelations?: Maybe<Array<UserCompanyRelationProxy>>;
  website?: Maybe<Scalars['String']['output']>;
};


export type CompanyProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  salaryValue?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyBranchTypesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyBranchesPaginatedArgs = {
  branchTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyClientsArgs = {
  amountOfVisits?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyEmployeePositionsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyEmployeesArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  filterByNameAndPosition?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  positionId?: InputMaybe<Scalars['Int']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyEmployeesListArgs = {
  positionId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyEmployeesNotInBranchArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  excludeBranchId: Scalars['Int']['input'];
};


export type CompanyProxyLanguagesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyMeMenuCategoriesArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  onlyTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
  onlyWithItemRelations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyProxyMeMenuCategoriesPaginatedArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyMenuItemsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  menuCategoryId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyMenuItemsListArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  excludeForCategory?: InputMaybe<Scalars['Boolean']['input']>;
  excludedCategoryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyMenuSupplementsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  menuCategoryId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyMenuSupplementsListArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  menuCategoryId?: InputMaybe<Scalars['Int']['input']>;
  onlyParent?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyModulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isOnlyParents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyProxyPaidFeaturesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyPaidFeaturesPaginatedArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyPaymentOrdersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyProductCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyProductsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyProductsListArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyReviewsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  employeeEmail?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  reviewSortField?: InputMaybe<Scalars['String']['input']>;
  reviewType?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxySalaryPaymentsArgs = {
  branchId: Scalars['Int']['input'];
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyServiceCategoriesNewArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyServicesArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyFromBookings?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  withoutArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyProxyServicesListArgs = {
  accessibility?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlineBooking?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyProxyServicesListForTechMapArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  techMapId: Scalars['Int']['input'];
};


export type CompanyProxyTechMapListForServicesArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['Int']['input'];
};


export type CompanyProxyTechnologicalMapCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyTechnologicalMapCategoriesNewArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyTechnologicalMapsArgs = {
  bookingUuid?: InputMaybe<Scalars['Uuid']['input']>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  inStockProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  techMapId?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyTechnologicalMapsListArgs = {
  inStockProducts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyProxyUserCompanyRelationsArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyTypeProxy = {
  __typename?: 'CompanyTypeProxy';
  branches?: Maybe<Array<BranchProxy>>;
  companies?: Maybe<Array<CompanyProxy>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};


export type CompanyTypeProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type Country = {
  __typename?: 'Country';
  continentName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isInEuropeanUnion: Scalars['Boolean']['output'];
  isoCode: Scalars['String']['output'];
  localeCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CountryProxy = {
  __typename?: 'CountryProxy';
  alpha3IsoCode?: Maybe<Scalars['String']['output']>;
  branches?: Maybe<Array<BranchProxy>>;
  cities?: Maybe<Array<CityProxy>>;
  companies?: Maybe<Array<CompanyProxy>>;
  continentCode?: Maybe<Scalars['String']['output']>;
  continentName?: Maybe<Scalars['String']['output']>;
  currencies?: Maybe<Array<CurrencyProxy>>;
  europeanUnion: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isoCode?: Maybe<Scalars['String']['output']>;
  localeCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneCode?: Maybe<PhoneCodeProxy>;
  slug: Scalars['String']['output'];
  timezone?: Maybe<Array<Maybe<TimeZoneProxy>>>;
};


export type CountryProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CountryProxyCitiesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CountryProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CountryProxyCurrenciesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum Currency {
  Eur = 'EUR',
  Uah = 'UAH',
  Usd = 'USD'
}

export type CurrencyProxy = {
  __typename?: 'CurrencyProxy';
  code?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<CompanyProxy>>;
  countries?: Maybe<Array<CountryProxy>>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySign?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};


export type CurrencyProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrencyProxyCountriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomDayPeriodProxy = {
  __typename?: 'CustomDayPeriodProxy';
  customDay?: Maybe<CustomDayProxy>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
};


export type CustomDayPeriodProxyEndTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type CustomDayPeriodProxyStartTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type CustomDayProxy = {
  __typename?: 'CustomDayProxy';
  branch?: Maybe<BranchProxy>;
  customDayPeriods?: Maybe<Array<CustomDayPeriodProxy>>;
  date?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
};


export type CustomDayProxyCustomDayPeriodsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomDayProxyDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type CustomPlaceProxy = {
  __typename?: 'CustomPlaceProxy';
  country: CountryProxy;
  id: Scalars['Int']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CustomReservationInput = {
  client: ClientReservationInput;
  comment?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  flexibility: ReservationFlexibility;
  guestsCount: Scalars['Int']['input'];
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['String']['input'];
  reservationAt: Scalars['DateTime']['input'];
  restaurantName: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};

export type DateTimeFormat = {
  __typename?: 'DateTimeFormat';
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DateTimeFormatProxy = {
  __typename?: 'DateTimeFormatProxy';
  branches?: Maybe<Array<BranchProxy>>;
  companies?: Maybe<Array<CompanyProxy>>;
  format: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};


export type DateTimeFormatProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type DateTimeFormatProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DayProxy = {
  __typename?: 'DayProxy';
  branchWorkSchedules?: Maybe<Array<BranchWorkScheduleProxy>>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  workingDayPeriods?: Maybe<Array<WorkingDayPeriodProxy>>;
};


export type DayProxyBranchWorkSchedulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type DayProxyWorkingDayPeriodsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DismissalEmployeeProxy = {
  __typename?: 'DismissalEmployeeProxy';
  comment?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  employeeDismissalReason?: Maybe<EmployeeDismissalReasonProxy>;
  endDateCooperation?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};


export type DismissalEmployeeProxyEndDateCooperationArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeBookingProxy = {
  __typename?: 'EmployeeBookingProxy';
  aboutMe?: Maybe<Scalars['String']['output']>;
  allowDefault: Scalars['Boolean']['output'];
  avgRating?: Maybe<Scalars['Float']['output']>;
  closestBookingDate?: Maybe<Scalars['String']['output']>;
  closestBookingDateTimes?: Maybe<Array<BookingTime>>;
  employeeServiceRelation?: Maybe<EmployeeServiceRelationProxy>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lastReviews?: Maybe<Array<ReviewProxy>>;
  name: Scalars['String']['output'];
  patronymic?: Maybe<Scalars['String']['output']>;
  position?: Maybe<EmployeePositionProxy>;
  qualificationConfirmations?: Maybe<Array<QualificationConfirmationProxy>>;
  reviewCount: Scalars['Int']['output'];
  specialization?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmployeeStatusProxy>;
  surname?: Maybe<Scalars['String']['output']>;
};


export type EmployeeBookingProxyClosestBookingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeBookingProxyQualificationConfirmationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeDismissalReasonProxy = {
  __typename?: 'EmployeeDismissalReasonProxy';
  dismissalEmployees?: Maybe<Array<DismissalEmployeeProxy>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type EmployeeDismissalReasonProxyDismissalEmployeesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeePaginated = {
  __typename?: 'EmployeePaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  employees?: Maybe<Array<EmployeeProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EmployeePositionPaginated = {
  __typename?: 'EmployeePositionPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  employeePositions?: Maybe<Array<EmployeePositionProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EmployeePositionProxy = {
  __typename?: 'EmployeePositionProxy';
  company?: Maybe<CompanyProxy>;
  description?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Array<EmployeeProxy>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type EmployeePositionProxyEmployeesArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeProxy = {
  __typename?: 'EmployeeProxy';
  ServiceCategorySalaries?: Maybe<Array<ServiceCategorySalaryProxy>>;
  aboutMe?: Maybe<Scalars['String']['output']>;
  bookings?: Maybe<BookingPaginated>;
  company?: Maybe<CompanyProxy>;
  contract?: Maybe<Scalars['String']['output']>;
  customDays?: Maybe<Array<CustomDayProxy>>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dismissalEmployee?: Maybe<DismissalEmployeeProxy>;
  email: Scalars['String']['output'];
  employeeServiceRelations?: Maybe<Array<EmployeeServiceRelationProxy>>;
  employeeServices?: Maybe<EmployeeServicesPaginated>;
  employeeServicesList?: Maybe<Array<ServiceProxy>>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAnyBookingsPerDateRange: Scalars['Boolean']['output'];
  isScheduleActive: Scalars['Boolean']['output'];
  itn?: Maybe<Scalars['String']['output']>;
  manualBlocking: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  originalContractName?: Maybe<Scalars['String']['output']>;
  passportData?: Maybe<Scalars['String']['output']>;
  patronymic?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  position?: Maybe<EmployeePositionProxy>;
  qualificationConfirmations?: Maybe<Array<QualificationConfirmationProxy>>;
  recordSetting?: Maybe<RecordSettingProxy>;
  reviews?: Maybe<Array<ReviewProxy>>;
  role?: Maybe<RoleProxy>;
  salaryPayments?: Maybe<SalaryPaymentPaginated>;
  specialization?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmployeeStatusProxy>;
  surname?: Maybe<Scalars['String']['output']>;
  tariffBlocking: Scalars['Boolean']['output'];
  user?: Maybe<UserProxy>;
  userBranchRelations?: Maybe<Array<UserBranchRelationProxy>>;
  vacations?: Maybe<Array<VacationProxy>>;
  workSchedules?: Maybe<Array<WorkScheduleProxy>>;
};


export type EmployeeProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  excludeCustomDays?: InputMaybe<Scalars['Boolean']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  salaryValue?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxyCustomDaysArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxyDateOfBirthArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeProxyEmployeeServiceRelationsArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxyEmployeeServicesArgs = {
  accessibility?: InputMaybe<Scalars['Boolean']['input']>;
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  filterByEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  onlineBooking?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeProxyEmployeeServicesListArgs = {
  accessibility?: InputMaybe<Scalars['Boolean']['input']>;
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  filterByEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  onlineBooking?: InputMaybe<Scalars['Boolean']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeProxyIsAnyBookingsPerDateRangeArgs = {
  branchId: Scalars['Int']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type EmployeeProxyQualificationConfirmationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxyReviewsArgs = {
  companyId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxySalaryPaymentsArgs = {
  branchId: Scalars['Int']['input'];
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeProxyUserBranchRelationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxyVacationsArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxyWorkSchedulesArgs = {
  companyId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeServiceRelationProxy = {
  __typename?: 'EmployeeServiceRelationProxy';
  deleted: Scalars['Boolean']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  online: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  salaryType?: Maybe<Scalars['Int']['output']>;
  salaryValue?: Maybe<Scalars['Float']['output']>;
  service?: Maybe<ServiceProxy>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type EmployeeServiceRelationProxyDurationArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeServiceRelationProxyUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeServicesPaginated = {
  __typename?: 'EmployeeServicesPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  employeeServices?: Maybe<Array<ServiceProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeStatusProxy = {
  __typename?: 'EmployeeStatusProxy';
  constId?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Array<EmployeeProxy>>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};


export type EmployeeStatusProxyEmployeesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeWorkScheduleSetting = {
  __typename?: 'EmployeeWorkScheduleSetting';
  branch: Branch;
  defaultWeek?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GenderProxy = {
  __typename?: 'GenderProxy';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Language = {
  __typename?: 'Language';
  id: Scalars['ID']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LanguageProxy = {
  __typename?: 'LanguageProxy';
  branches?: Maybe<Array<BranchProxy>>;
  companies?: Maybe<Array<CompanyProxy>>;
  companiesByMessageLanguage?: Maybe<Array<CompanyProxy>>;
  companiesByPrimaryLanguage?: Maybe<Array<CompanyProxy>>;
  id: Scalars['Int']['output'];
  isMessage: Scalars['Boolean']['output'];
  isoCode: Scalars['String']['output'];
  menus?: Maybe<Array<MenuProxy>>;
  name: Scalars['String']['output'];
};


export type LanguageProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageProxyCompaniesByMessageLanguageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageProxyCompaniesByPrimaryLanguageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageProxyMenusArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type LogbookSetting = {
  __typename?: 'LogbookSetting';
  branch: Branch;
  defaultDay?: Maybe<Scalars['String']['output']>;
  defaultView?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isQuickBooking?: Maybe<Scalars['Boolean']['output']>;
  pastCreateStatus?: Maybe<Scalars['String']['output']>;
  useClientData?: Maybe<Scalars['Boolean']['output']>;
};

export type MeBookingBranchConfigProxy = {
  __typename?: 'MeBookingBranchConfigProxy';
  branch?: Maybe<BranchProxy>;
  jsConfig?: Maybe<Scalars['String']['output']>;
};

export type MenuAllergenProxy = {
  __typename?: 'MenuAllergenProxy';
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  items?: Maybe<Array<MenuItemProxy>>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


export type MenuAllergenProxyItemsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuCategoryIconProxy = {
  __typename?: 'MenuCategoryIconProxy';
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  path?: Maybe<Scalars['String']['output']>;
};

export type MenuCategoryPaginated = {
  __typename?: 'MenuCategoryPaginated';
  categories?: Maybe<Array<MenuCategoryProxy>>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MenuCategoryProxy = {
  __typename?: 'MenuCategoryProxy';
  childCategories?: Maybe<Array<MenuCategoryProxy>>;
  comment?: Maybe<Scalars['String']['output']>;
  company: CompanyProxy;
  deleted: Scalars['Boolean']['output'];
  descriptionOrigin?: Maybe<Scalars['String']['output']>;
  descriptionTranslations?: Maybe<Array<TranslationProxy>>;
  favicon?: Maybe<MenuCategoryIconProxy>;
  id: Scalars['Int']['output'];
  isExistsInMenu: Scalars['Boolean']['output'];
  menuItems?: Maybe<Array<MenuItemProxy>>;
  menuItemsMerged?: Maybe<Array<MenuItemProxy>>;
  menuItemsNotInCategory?: Maybe<Array<MenuItemProxy>>;
  name?: Maybe<Scalars['String']['output']>;
  nameOrigin?: Maybe<Scalars['String']['output']>;
  nameTranslations?: Maybe<Array<TranslationProxy>>;
  numberOfItems: Scalars['Int']['output'];
  parentCategory?: Maybe<MenuCategoryProxy>;
};


export type MenuCategoryProxyChildCategoriesArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  excludeChildren?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuCategoryProxyCommentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuCategoryProxyIsExistsInMenuArgs = {
  menuId?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuCategoryProxyMenuItemsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
  needDirectlyFromCategory?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MenuCategoryProxyMenuItemsMergedArgs = {
  menuId: Scalars['Int']['input'];
};


export type MenuCategoryProxyMenuItemsNotInCategoryArgs = {
  menuId: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  searchCategoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuCategoryProxyNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuCategoryProxyNumberOfItemsArgs = {
  menuId?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuCategoryRelationProxy = {
  __typename?: 'MenuCategoryRelationProxy';
  category: MenuCategoryProxy;
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  itemRelations?: Maybe<Array<MenuItemRelationProxy>>;
  menu: MenuProxy;
  subcategoryRelations?: Maybe<Array<MenuCategoryRelationProxy>>;
};

export type MenuItemPaginated = {
  __typename?: 'MenuItemPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<MenuItemProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MenuItemPortionProxy = {
  __typename?: 'MenuItemPortionProxy';
  id: Scalars['Int']['output'];
  item: MenuItemProxy;
  name?: Maybe<Scalars['String']['output']>;
  nameOrigin?: Maybe<Scalars['String']['output']>;
  nameTranslations?: Maybe<Array<TranslationProxy>>;
  price: Scalars['Float']['output'];
  volume: Scalars['Float']['output'];
};


export type MenuItemPortionProxyNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type MenuItemProxy = {
  __typename?: 'MenuItemProxy';
  allergens?: Maybe<Array<MenuAllergenProxy>>;
  availableDeliveryMenus?: Maybe<Array<MenuProxy>>;
  availableDineInMenus?: Maybe<Array<MenuProxy>>;
  availablePickupMenus?: Maybe<Array<MenuProxy>>;
  categories?: Maybe<Array<MenuCategoryProxy>>;
  company: CompanyProxy;
  composition?: Maybe<Scalars['String']['output']>;
  compositionOrigin?: Maybe<Scalars['String']['output']>;
  compositionTranslations?: Maybe<Array<TranslationProxy>>;
  cookingTime?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionOrigin?: Maybe<Scalars['String']['output']>;
  descriptionTranslations?: Maybe<Array<TranslationProxy>>;
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAvailableForCurrentMenu: Scalars['Boolean']['output'];
  isLongCookingTime: Scalars['Boolean']['output'];
  markers?: Maybe<Array<MenuMarkerProxy>>;
  menus?: Maybe<Array<MenuProxy>>;
  name?: Maybe<Scalars['String']['output']>;
  nameOrigin?: Maybe<Scalars['String']['output']>;
  nameTranslations?: Maybe<Array<TranslationProxy>>;
  portions?: Maybe<Array<MenuItemPortionProxy>>;
  supplements?: Maybe<Array<MenuSupplementProxy>>;
  types?: Maybe<Array<MenuTypeProxy>>;
  unit: UnitProxy;
};


export type MenuItemProxyAllergensArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemProxyCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemProxyCompositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuItemProxyDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuItemProxyIsAvailableForCurrentMenuArgs = {
  menuId: Scalars['Int']['input'];
};


export type MenuItemProxyMarkersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemProxyNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuItemProxyPortionsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemProxySupplementsArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type MenuItemProxyTypesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemRelationProxy = {
  __typename?: 'MenuItemRelationProxy';
  categoryRelation: MenuCategoryRelationProxy;
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  item: MenuItemProxy;
};

export type MenuMarkerProxy = {
  __typename?: 'MenuMarkerProxy';
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  items?: Maybe<Array<MenuItemProxy>>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


export type MenuMarkerProxyItemsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuPaginated = {
  __typename?: 'MenuPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  menus?: Maybe<Array<MenuProxy>>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MenuProxy = {
  __typename?: 'MenuProxy';
  branch: BranchProxy;
  categories?: Maybe<Array<MenuCategoryProxy>>;
  categoriesNotInMenu?: Maybe<Array<MenuCategoryProxy>>;
  categoryRelations?: Maybe<Array<MenuCategoryRelationProxy>>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAnyItems: Scalars['Boolean']['output'];
  isToFill: Scalars['Boolean']['output'];
  itemRelations?: Maybe<Array<MenuItemRelationProxy>>;
  items?: Maybe<Array<MenuItemProxy>>;
  languages?: Maybe<Array<LanguageProxy>>;
  name: Scalars['String']['output'];
  numberOfCategories: Scalars['Int']['output'];
  numberOfItems: Scalars['Int']['output'];
  primaryLanguage?: Maybe<LanguageProxy>;
  qrMenuLink: Scalars['String']['output'];
  qrMenuQrCode: Scalars['String']['output'];
  status: MenuStatusProxy;
  type: MenuTypeProxy;
};


export type MenuProxyCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  onlyTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MenuProxyCategoriesNotInMenuArgs = {
  onlyTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MenuProxyItemRelationsArgs = {
  categoryRelationId?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuProxyItemsArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type MenuProxyLanguagesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuProxyQrMenuLinkArgs = {
  menuId?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuProxyQrMenuQrCodeArgs = {
  menuId?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuStatusProxy = {
  __typename?: 'MenuStatusProxy';
  id: Scalars['Int']['output'];
  menus?: Maybe<Array<MenuProxy>>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


export type MenuStatusProxyMenusArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuSupplementPaginated = {
  __typename?: 'MenuSupplementPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  supplements?: Maybe<Array<MenuSupplementProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MenuSupplementProxy = {
  __typename?: 'MenuSupplementProxy';
  company: CompanyProxy;
  deleted: Scalars['Boolean']['output'];
  dependentSupplements?: Maybe<Array<MenuSupplementProxy>>;
  groupName?: Maybe<Scalars['String']['output']>;
  groupNameOrigin?: Maybe<Scalars['String']['output']>;
  groupNameTranslations?: Maybe<Array<TranslationProxy>>;
  id: Scalars['Int']['output'];
  isRequireOnOrder?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<MenuItemProxy>>;
  maxCountOnOrder?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameOrigin?: Maybe<Scalars['String']['output']>;
  nameTranslations?: Maybe<Array<TranslationProxy>>;
  numberOfOption?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<MenuSupplementProxy>>;
  parent?: Maybe<MenuSupplementProxy>;
  price?: Maybe<Scalars['Float']['output']>;
};


export type MenuSupplementProxyDependentSupplementsArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MenuSupplementProxyGroupNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSupplementProxyItemsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuSupplementProxyNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSupplementProxyOptionsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuTypeProxy = {
  __typename?: 'MenuTypeProxy';
  id: Scalars['Int']['output'];
  items?: Maybe<Array<MenuItemProxy>>;
  menus?: Maybe<Array<MenuProxy>>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


export type MenuTypeProxyItemsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuTypeProxyMenusArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ModuleProxy = {
  __typename?: 'ModuleProxy';
  active: Scalars['Boolean']['output'];
  childModules?: Maybe<Array<Maybe<ModuleProxy>>>;
  companies?: Maybe<Array<CompanyProxy>>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isFreeAccess: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPaymentRequired: Scalars['Boolean']['output'];
  monthlyTariffPlan?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentModule?: Maybe<ModuleProxy>;
  yearlyTariffPlan?: Maybe<Scalars['String']['output']>;
};


export type ModuleProxyActiveArgs = {
  companyId: Scalars['Int']['input'];
};


export type ModuleProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ModuleProxyIsPaidArgs = {
  companyId: Scalars['Int']['input'];
};

export type OffDayProxy = {
  __typename?: 'OffDayProxy';
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  workSchedule?: Maybe<WorkScheduleProxy>;
};


export type OffDayProxyDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OutOfStockProductsPaginated = {
  __typename?: 'OutOfStockProductsPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<ProductProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaidFeaturePaginated = {
  __typename?: 'PaidFeaturePaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  paidFeatures?: Maybe<Array<PaidFeatureProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaidFeatureProxy = {
  __typename?: 'PaidFeatureProxy';
  company?: Maybe<CompanyProxy>;
  currency?: Maybe<Currency>;
  dateOfEnd?: Maybe<Scalars['String']['output']>;
  dateOfLastPayment: Scalars['String']['output'];
  dateOfStart?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isYearly: Scalars['Boolean']['output'];
  name?: Maybe<Tariff>;
  paymentOrder?: Maybe<PaymentOrderProxy>;
  paymentOrdersByDate?: Maybe<Array<PaymentOrderProxy>>;
  price: Scalars['Float']['output'];
  status?: Maybe<SubscriptionStatus>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionRegistrationDate?: Maybe<Scalars['String']['output']>;
};


export type PaidFeatureProxyDateOfEndArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type PaidFeatureProxyDateOfLastPaymentArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type PaidFeatureProxyDateOfStartArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type PaidFeatureProxySubscriptionRegistrationDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentOrderProxy = {
  __typename?: 'PaymentOrderProxy';
  amount?: Maybe<Scalars['Float']['output']>;
  company?: Maybe<CompanyProxy>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  paidFeatures?: Maybe<PaidFeatureProxy>;
  parentOrder?: Maybe<PaymentOrderProxy>;
  paymentOrders?: Maybe<Array<PaymentOrderProxy>>;
  planId: Scalars['Int']['output'];
  status?: Maybe<PaymentOrderStatus>;
  test: Scalars['Boolean']['output'];
  user?: Maybe<UserProxy>;
};


export type PaymentOrderProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type PaymentOrderProxyPaymentOrdersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum PaymentOrderStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum PermissionScope {
  All = 'ALL',
  Self = 'SELF'
}

export type PhoneCodeProxy = {
  __typename?: 'PhoneCodeProxy';
  code: Scalars['String']['output'];
  country?: Maybe<CountryProxy>;
  id: Scalars['Int']['output'];
};

export type ProductAttributesProxy = {
  __typename?: 'ProductAttributesProxy';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<ProductProxy>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProductCategoryNewProxy = {
  __typename?: 'ProductCategoryNewProxy';
  childCategories?: Maybe<Array<Maybe<ProductCategoryNewProxy>>>;
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyProxy>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<ProductCategoryNewProxy>;
  products?: Maybe<Array<ProductProxy>>;
};


export type ProductCategoryNewProxyChildCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ProductCategoryNewProxyProductsArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategoryProxy = {
  __typename?: 'ProductCategoryProxy';
  company?: Maybe<CompanyProxy>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  productSubcategories?: Maybe<Array<ProductSubcategoryProxy>>;
  suppliers?: Maybe<Array<SupplierProxy>>;
};


export type ProductCategoryProxyProductSubcategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductCategoryProxySuppliersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPaginated = {
  __typename?: 'ProductPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<ProductProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductProxy = {
  __typename?: 'ProductProxy';
  alternativeUnit?: Maybe<UnitProxy>;
  alternativeUnitGroup?: Maybe<UnitGroupProxy>;
  alternativeValue?: Maybe<Scalars['Float']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyProxy>;
  cost?: Maybe<Scalars['String']['output']>;
  criticalResidue?: Maybe<Scalars['Int']['output']>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['String']['output'];
  productAttributes?: Maybe<Array<ProductAttributesProxy>>;
  productCategoryNew?: Maybe<ProductCategoryNewProxy>;
  productStockStatus?: Maybe<Scalars['String']['output']>;
  remnantsPerBranch: Scalars['String']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  storageProductRelationHistories?: Maybe<Array<StorageProductRelationProxy>>;
  storageProductRelations?: Maybe<Array<StorageProductRelationProxy>>;
  storages?: Maybe<Array<StorageProxy>>;
  subcategory?: Maybe<ProductSubcategoryProxy>;
  techMapProducts?: Maybe<TechMapProductPaginated>;
  technologicalMapProductRelations?: Maybe<Array<TechnologicalMapProductRelationProxy>>;
  unit?: Maybe<UnitProxy>;
  unitGroup?: Maybe<UnitGroupProxy>;
  units?: Maybe<Array<UnitProxy>>;
};


export type ProductProxyProductAttributesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductProxyRemnantsPerBranchArgs = {
  branchId: Scalars['Int']['input'];
};


export type ProductProxyStorageProductRelationHistoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductProxyStorageProductRelationsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductProxyStoragesArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductProxyTechMapProductsArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  techMapId: Scalars['Int']['input'];
};


export type ProductProxyTechnologicalMapProductRelationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  techMapId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductSubcategoryProxy = {
  __typename?: 'ProductSubcategoryProxy';
  category?: Maybe<ProductCategoryProxy>;
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  products?: Maybe<Array<ProductProxy>>;
  suppliers?: Maybe<Array<SupplierProxy>>;
};


export type ProductSubcategoryProxyProductsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductSubcategoryProxySuppliersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type QualificationConfirmationProxy = {
  __typename?: 'QualificationConfirmationProxy';
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
};

export type RecordSettingProxy = {
  __typename?: 'RecordSettingProxy';
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  isDefaultEmployee: Scalars['Boolean']['output'];
  isOnlineSignUpAvailable: Scalars['Boolean']['output'];
  isReviewsAvailable: Scalars['Boolean']['output'];
  isShowSurname: Scalars['Boolean']['output'];
};

export enum ReservationDiscoverySource {
  Friend = 'FRIEND',
  Google = 'GOOGLE',
  Other = 'OTHER',
  Returning = 'RETURNING',
  Skipped = 'SKIPPED',
  Stumbled = 'STUMBLED'
}

export enum ReservationFlexibility {
  Hour_1 = 'HOUR_1',
  Hour_2 = 'HOUR_2',
  Hour_3 = 'HOUR_3',
  None = 'NONE'
}

export type ReservationInput = {
  branch: Scalars['Int']['input'];
  client: ClientReservationInput;
  comment?: InputMaybe<Scalars['String']['input']>;
  flexibility: ReservationFlexibility;
  guestsCount: Scalars['Int']['input'];
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  reservationAt: Scalars['DateTime']['input'];
  rwgToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReservationStatus>;
  testNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  userUuid: Scalars['String']['input'];
};

export type ReservationPaginated = {
  __typename?: 'ReservationPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  reservations?: Maybe<Array<ReservationProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ReservationProxy = {
  __typename?: 'ReservationProxy';
  branch?: Maybe<BranchProxy>;
  client: ClientProxy;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customPlace?: Maybe<CustomPlaceProxy>;
  flexibility: ReservationFlexibility;
  guestsCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isPremium: Scalars['Boolean']['output'];
  moderatorComment?: Maybe<Scalars['String']['output']>;
  reservationAt: Scalars['String']['output'];
  status: ReservationStatus;
  updatedAt: Scalars['String']['output'];
  userUuid: Scalars['Uuid']['output'];
  uuid: Scalars['Uuid']['output'];
};


export type ReservationProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ReservationProxyReservationAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ReservationProxyUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export enum ReservationSortField {
  BranchName = 'BRANCH_NAME',
  CreatedAt = 'CREATED_AT',
  Premium = 'PREMIUM',
  ReservationAt = 'RESERVATION_AT',
  Status = 'STATUS'
}

export type ReservationSortInput = {
  order: Order;
  sortField: ReservationSortField;
};

export type ReservationSourceInput = {
  reservationUuid: Scalars['String']['input'];
  source: ReservationDiscoverySource;
};

export enum ReservationStatus {
  CancelledByUser = 'CANCELLED_BY_USER',
  Confirmed = 'CONFIRMED',
  InProgress = 'IN_PROGRESS',
  NoConnection = 'NO_CONNECTION',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  WaitingForOpening = 'WAITING_FOR_OPENING'
}

export type ReservationUpdateInput = {
  client: ClientReservationInput;
};

export type RestaurantAddRequestInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  countryIsoCode: Scalars['String']['input'];
  googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  venueName: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantAddRequestPaginated = {
  __typename?: 'RestaurantAddRequestPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  requests?: Maybe<Array<RestaurantAddRequestProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RestaurantAddRequestProxy = {
  __typename?: 'RestaurantAddRequestProxy';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhone: Scalars['String']['output'];
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  googleMapsUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status: RestaurantAddRequestStatus;
  updatedAt: Scalars['String']['output'];
  venueName: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


export type RestaurantAddRequestProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type RestaurantAddRequestProxyUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export enum RestaurantAddRequestStatus {
  Approved = 'APPROVED',
  Contacted = 'CONTACTED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Reviewed = 'REVIEWED'
}

export enum RestaurantDeleteReason {
  IncorrectInfo = 'INCORRECT_INFO',
  NotAssociated = 'NOT_ASSOCIATED',
  NotListed = 'NOT_LISTED',
  NoBookings = 'NO_BOOKINGS',
  Other = 'OTHER'
}

export type RestaurantDeleteRequestInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  countryIsoCode: Scalars['String']['input'];
  googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
  reason: RestaurantDeleteReason;
  role: Scalars['String']['input'];
  venueName: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantDeleteRequestPaginated = {
  __typename?: 'RestaurantDeleteRequestPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  requests?: Maybe<Array<RestaurantDeleteRequestProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RestaurantDeleteRequestProxy = {
  __typename?: 'RestaurantDeleteRequestProxy';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhone: Scalars['String']['output'];
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  googleMapsUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  reason: RestaurantDeleteReason;
  reasonLabel: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  status: RestaurantDeleteRequestStatus;
  updatedAt: Scalars['String']['output'];
  venueName: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


export type RestaurantDeleteRequestProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type RestaurantDeleteRequestProxyUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export enum RestaurantDeleteRequestStatus {
  New = 'NEW',
  Processed = 'PROCESSED',
  Rejected = 'REJECTED',
  UnderReview = 'UNDER_REVIEW',
  Verified = 'VERIFIED'
}

export type RestaurantRating = {
  __typename?: 'RestaurantRating';
  atmosphereRating: Scalars['Float']['output'];
  atmosphereReviewsCount: Scalars['Int']['output'];
  foodRating: Scalars['Float']['output'];
  foodReviewsCount: Scalars['Int']['output'];
  overallRating: Scalars['Float']['output'];
  serviceRating: Scalars['Float']['output'];
  serviceReviewsCount: Scalars['Int']['output'];
  totalReviews: Scalars['Int']['output'];
};

export enum RestaurantRequestSortField {
  CreatedAt = 'CREATED_AT',
  Status = 'STATUS',
  VenueName = 'VENUE_NAME'
}

export type RestaurantRequestSortInput = {
  order: Order;
  sortField: RestaurantRequestSortField;
};

export type RestaurantReviewInput = {
  atmosphereRating?: InputMaybe<Scalars['Int']['input']>;
  billPerPerson?: InputMaybe<ReviewBillPerPerson>;
  comment?: InputMaybe<Scalars['String']['input']>;
  foodRating?: InputMaybe<Scalars['Int']['input']>;
  overallRating: Scalars['Int']['input'];
  photos?: InputMaybe<Array<Scalars['Upload']['input']>>;
  serviceRating?: InputMaybe<Scalars['Int']['input']>;
  userUuid: Scalars['String']['input'];
};

export type RestaurantReviewPaginated = {
  __typename?: 'RestaurantReviewPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<Array<RestaurantReviewProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RestaurantReviewPhotoProxy = {
  __typename?: 'RestaurantReviewPhotoProxy';
  id: Scalars['Int']['output'];
  path: Scalars['String']['output'];
};

export type RestaurantReviewProxy = {
  __typename?: 'RestaurantReviewProxy';
  atmosphereRating?: Maybe<Scalars['Int']['output']>;
  billPerPerson?: Maybe<ReviewBillPerPerson>;
  branch: BranchProxy;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  foodRating?: Maybe<Scalars['Int']['output']>;
  overallRating: Scalars['Int']['output'];
  photos?: Maybe<Array<RestaurantReviewPhotoProxy>>;
  serviceRating?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
  userUuid: Scalars['Uuid']['output'];
  uuid: Scalars['Uuid']['output'];
};


export type RestaurantReviewProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type RestaurantReviewProxyUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export enum RestaurantReviewSortField {
  BranchName = 'BRANCH_NAME',
  CreatedAt = 'CREATED_AT',
  Photos = 'PHOTOS',
  Rating = 'RATING',
  Relevance = 'RELEVANCE'
}

export enum ReviewBillPerPerson {
  From_1 = 'FROM_1',
  From_10 = 'FROM_10',
  From_50 = 'FROM_50',
  From_100 = 'FROM_100'
}

export type ReviewPaginated = {
  __typename?: 'ReviewPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<Array<ReviewProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ReviewProxy = {
  __typename?: 'ReviewProxy';
  booking?: Maybe<BookingMainProxy>;
  createdAt?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


export type ReviewProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type RoleProxy = {
  __typename?: 'RoleProxy';
  branch?: Maybe<BranchProxy>;
  company?: Maybe<CompanyProxy>;
  companyAccesses?: Maybe<Array<CompanyAccessProxy>>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  userBranchRelations?: Maybe<Array<UserBranchRelationProxy>>;
  userCompanyRelations?: Maybe<Array<UserCompanyRelationProxy>>;
};


export type RoleProxyUserBranchRelationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type RoleProxyUserCompanyRelationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type SalaryPaymentPaginated = {
  __typename?: 'SalaryPaymentPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  salaryPayments?: Maybe<Array<SalaryPaymentProxy>>;
  totalBookingsAmount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SalaryPaymentProxy = {
  __typename?: 'SalaryPaymentProxy';
  bookings?: Maybe<BookingPaginated>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  paymentValue?: Maybe<Scalars['Float']['output']>;
  periodEnd?: Maybe<Scalars['String']['output']>;
  periodStart?: Maybe<Scalars['String']['output']>;
};


export type SalaryPaymentProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  salaryPaymentId?: InputMaybe<Scalars['Int']['input']>;
  salaryValue?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type SalaryPaymentProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type SalaryPaymentProxyPeriodEndArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type SalaryPaymentProxyPeriodStartArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceBookingProxy = {
  __typename?: 'ServiceBookingProxy';
  currencyCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  serviceCategoryNew?: Maybe<ServiceCategoryNewProxy>;
};


export type ServiceBookingProxyDurationArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceCategoryNewProxy = {
  __typename?: 'ServiceCategoryNewProxy';
  childCategories?: Maybe<Array<Maybe<ServiceCategoryNewProxy>>>;
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyProxy>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<ServiceCategoryNewProxy>;
  services?: Maybe<Array<ServiceProxy>>;
};


export type ServiceCategoryNewProxyChildCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ServiceCategoryNewProxyServicesArgs = {
  bookingUuid?: InputMaybe<Scalars['Uuid']['input']>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  dateTime?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceCategorySalaryProxy = {
  __typename?: 'ServiceCategorySalaryProxy';
  deleted: Scalars['Boolean']['output'];
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  salaryType?: Maybe<Scalars['Int']['output']>;
  salaryValue?: Maybe<Scalars['Float']['output']>;
  selectedAll: Scalars['Boolean']['output'];
  serviceCategory?: Maybe<Array<ServiceCategoryNewProxy>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type ServiceCategorySalaryProxyUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceEmployeesPaginated = {
  __typename?: 'ServiceEmployeesPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  serviceEmployees?: Maybe<Array<EmployeeProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ServicePaginated = {
  __typename?: 'ServicePaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<ServiceProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ServiceProxy = {
  __typename?: 'ServiceProxy';
  bookings?: Maybe<BookingPaginated>;
  company?: Maybe<CompanyProxy>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  employeeServiceRelations?: Maybe<Array<EmployeeServiceRelationProxy>>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  onlineRegistration: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  serviceCategoryNew?: Maybe<ServiceCategoryNewProxy>;
  serviceEmployees?: Maybe<ServiceEmployeesPaginated>;
  serviceEmployeesList?: Maybe<Array<EmployeeProxy>>;
  technologicalMapServiceRelations?: Maybe<Array<TechnologicalMapServiceRelationProxy>>;
};


export type ServiceProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceProxyDurationArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ServiceProxyEmployeeServiceRelationsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceProxyServiceEmployeesArgs = {
  branchId: Scalars['Int']['input'];
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  employeeName?: InputMaybe<Scalars['String']['input']>;
  employeePosition?: InputMaybe<Scalars['Int']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  filterByService?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceProxyServiceEmployeesListArgs = {
  branchId: Scalars['Int']['input'];
  employeeName?: InputMaybe<Scalars['String']['input']>;
  employeePosition?: InputMaybe<Scalars['Int']['input']>;
  filterByService?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceProxyTechnologicalMapServiceRelationsArgs = {
  connect?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  techMapId?: InputMaybe<Scalars['Int']['input']>;
};

export type StoragePaginated = {
  __typename?: 'StoragePaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  storages?: Maybe<Array<StorageProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StorageProductOperationHistoryDataProxy = {
  __typename?: 'StorageProductOperationHistoryDataProxy';
  alternativeUnit?: Maybe<UnitProxy>;
  client?: Maybe<ClientProxy>;
  employee?: Maybe<EmployeeProxy>;
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  operationHistory?: Maybe<StorageProductOperationHistoryProxy>;
  storage?: Maybe<StorageProxy>;
  unit?: Maybe<UnitProxy>;
  value?: Maybe<Scalars['String']['output']>;
};

export type StorageProductOperationHistoryProxy = {
  __typename?: 'StorageProductOperationHistoryProxy';
  changeTime?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  exists: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  storageProductOperationHistoryData?: Maybe<Array<StorageProductOperationHistoryDataProxy>>;
  storageProductRelationHistory?: Maybe<StorageProductRelationHistoryProxy>;
};


export type StorageProductOperationHistoryProxyChangeTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type StorageProductOperationHistoryProxyStorageProductOperationHistoryDataArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type StorageProductPaginated = {
  __typename?: 'StorageProductPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  storageProductRelations?: Maybe<Array<StorageProductRelationProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum StorageProductRelationHistoryAction {
  Arrival = 'ARRIVAL',
  BookingWriteOff = 'BOOKING_WRITE_OFF',
  Movement = 'MOVEMENT',
  Sale = 'SALE',
  WriteOff = 'WRITE_OFF'
}

export type StorageProductRelationHistoryPaginatedType = {
  __typename?: 'StorageProductRelationHistoryPaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  entities?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StorageProductRelationHistoryProxy = {
  __typename?: 'StorageProductRelationHistoryProxy';
  action?: Maybe<StorageProductRelationHistoryAction>;
  amount?: Maybe<Scalars['String']['output']>;
  booking?: Maybe<BookingMainProxy>;
  client?: Maybe<ClientProxy>;
  comment?: Maybe<Scalars['String']['output']>;
  cost: Scalars['String']['output'];
  date?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  edited: Scalars['Boolean']['output'];
  employee?: Maybe<EmployeeProxy>;
  historyAction?: Maybe<StorageProductRelationHistoryAction>;
  historyCreator?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  mainQuantity?: Maybe<Scalars['Float']['output']>;
  mainUnit?: Maybe<UnitProxy>;
  operationHistories?: Maybe<Array<StorageProductOperationHistoryProxy>>;
  operationNumber?: Maybe<Scalars['Uuid']['output']>;
  operationNumberReadable?: Maybe<Scalars['String']['output']>;
  operationQuantity?: Maybe<Scalars['Float']['output']>;
  operationUnit?: Maybe<UnitProxy>;
  paymentType?: Maybe<Scalars['String']['output']>;
  price: Scalars['String']['output'];
  product?: Maybe<ProductProxy>;
  quantity?: Maybe<Scalars['BigInt']['output']>;
  quantityForRender?: Maybe<Scalars['String']['output']>;
  relatedSaleHistories?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  relationStorage?: Maybe<StorageProxy>;
  remnants?: Maybe<Scalars['BigInt']['output']>;
  remnantsForRender?: Maybe<Scalars['String']['output']>;
  storage?: Maybe<StorageProxy>;
  supplier?: Maybe<SupplierProxy>;
  techMap?: Maybe<TechnologicalMapProxy>;
  unit?: Maybe<UnitProxy>;
  user?: Maybe<UserProxy>;
  writeOffEditUnits?: Maybe<Array<UnitProxy>>;
  writeOffReason?: Maybe<WriteOffReasonProxy>;
};


export type StorageProductRelationHistoryProxyDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type StorageProductRelationProxy = {
  __typename?: 'StorageProductRelationProxy';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mainQuantity?: Maybe<Scalars['Float']['output']>;
  mainUnit?: Maybe<UnitProxy>;
  product?: Maybe<ProductProxy>;
  quantity?: Maybe<Scalars['BigInt']['output']>;
  quantityForRender?: Maybe<Scalars['String']['output']>;
  stockQuantity?: Maybe<Scalars['String']['output']>;
  storage?: Maybe<StorageProxy>;
  unit?: Maybe<UnitProxy>;
  unitGroup?: Maybe<UnitGroupProxy>;
};

export type StorageProxy = {
  __typename?: 'StorageProxy';
  branch?: Maybe<BranchProxy>;
  default: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  outOfStockProducts?: Maybe<OutOfStockProductsPaginated>;
  relatedStorageProductRelationHistories?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  storageProductRelationHistories?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  storageProductRelations?: Maybe<Array<StorageProductRelationProxy>>;
  storageProducts?: Maybe<StorageProductPaginated>;
  type?: Maybe<StorageTypeProxy>;
};


export type StorageProxyOutOfStockProductsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  nameSkuBarcode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type StorageProxyRelatedStorageProductRelationHistoriesArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type StorageProxyStorageProductRelationHistoriesArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type StorageProxyStorageProductRelationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type StorageProxyStorageProductsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  nameSkuBarcode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  stockStatus?: InputMaybe<Scalars['String']['input']>;
};

export type StorageTypeProxy = {
  __typename?: 'StorageTypeProxy';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  storages?: Maybe<Array<StorageProxy>>;
};


export type StorageTypeProxyStoragesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Paused = 'PAUSED'
}

export type SupplierProxy = {
  __typename?: 'SupplierProxy';
  company: CompanyProxy;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum Tariff {
  BaseModule = 'BASE_MODULE',
  MenuModule = 'MENU_MODULE',
  ServicesModule = 'SERVICES_MODULE',
  TariffLite = 'TARIFF_LITE',
  TariffPremium = 'TARIFF_PREMIUM',
  TariffStarter = 'TARIFF_STARTER',
  WarehousesModule = 'WAREHOUSES_MODULE'
}

export type TechMapCategoryNewProxy = {
  __typename?: 'TechMapCategoryNewProxy';
  childCategories?: Maybe<Array<Maybe<TechMapCategoryNewProxy>>>;
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyProxy>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<TechMapCategoryNewProxy>;
  techMaps?: Maybe<Array<TechnologicalMapProxy>>;
};


export type TechMapCategoryNewProxyChildCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type TechMapCategoryNewProxyTechMapsArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type TechMapProductPaginated = {
  __typename?: 'TechMapProductPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  techMapProducts?: Maybe<Array<TechnologicalMapProductRelationProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TechMapServicePaginated = {
  __typename?: 'TechMapServicePaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  techMapServices?: Maybe<Array<TechnologicalMapServiceRelationProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TechnologicalMapCategoryProxy = {
  __typename?: 'TechnologicalMapCategoryProxy';
  company?: Maybe<CompanyProxy>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  technologicalMapSubcategories?: Maybe<Array<TechnologicalMapSubcategoryProxy>>;
};


export type TechnologicalMapCategoryProxyTechnologicalMapSubcategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type TechnologicalMapPaginated = {
  __typename?: 'TechnologicalMapPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  technologicalMaps?: Maybe<Array<TechnologicalMapProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TechnologicalMapProductRelationProxy = {
  __typename?: 'TechnologicalMapProductRelationProxy';
  id: Scalars['Int']['output'];
  product?: Maybe<ProductProxy>;
  requiredQuantity?: Maybe<Scalars['Int']['output']>;
  technologicalMap?: Maybe<TechnologicalMapProxy>;
  unit?: Maybe<UnitProxy>;
};

export type TechnologicalMapProxy = {
  __typename?: 'TechnologicalMapProxy';
  bookings?: Maybe<BookingPaginated>;
  company?: Maybe<CompanyProxy>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  getProducts?: Maybe<AddProductTechMapPaginated>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  storageProductRelationHistoryList?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  techMapProducts?: Maybe<TechMapProductPaginated>;
  techMapServices?: Maybe<TechMapServicePaginated>;
  technologicalMapNewCategory?: Maybe<TechMapCategoryNewProxy>;
  technologicalMapProductRelations?: Maybe<Array<TechnologicalMapProductRelationProxy>>;
  technologicalMapServiceRelations?: Maybe<Array<TechnologicalMapServiceRelationProxy>>;
  technologicalMapSubcategory?: Maybe<TechnologicalMapSubcategoryProxy>;
};


export type TechnologicalMapProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type TechnologicalMapProxyGetProductsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  nameSkuBarcode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type TechnologicalMapProxyStorageProductRelationHistoryListArgs = {
  branch: Scalars['Int']['input'];
  operationNumber: Scalars['Uuid']['input'];
};


export type TechnologicalMapProxyTechMapProductsArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type TechnologicalMapProxyTechMapServicesArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['String']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type TechnologicalMapProxyTechnologicalMapProductRelationsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inStockProducts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TechnologicalMapProxyTechnologicalMapServiceRelationsArgs = {
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
};

export type TechnologicalMapServiceRelationProxy = {
  __typename?: 'TechnologicalMapServiceRelationProxy';
  connect: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  service?: Maybe<ServiceProxy>;
  technologicalMap?: Maybe<TechnologicalMapProxy>;
};

export type TechnologicalMapSubcategoryProxy = {
  __typename?: 'TechnologicalMapSubcategoryProxy';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  technologicalMapCategory?: Maybe<TechnologicalMapCategoryProxy>;
  technologicalMaps?: Maybe<Array<TechnologicalMapProxy>>;
};


export type TechnologicalMapSubcategoryProxyTechnologicalMapsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeZoneProxy = {
  __typename?: 'TimeZoneProxy';
  branches?: Maybe<Array<BranchProxy>>;
  companies?: Maybe<Array<CompanyProxy>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type TimeZoneProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type TimeZoneProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type TranslationProxy = {
  __typename?: 'TranslationProxy';
  locale: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UnitGroupProxy = {
  __typename?: 'UnitGroupProxy';
  alternativeProducts?: Maybe<Array<ProductProxy>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  products?: Maybe<Array<ProductProxy>>;
  storageProductRelations?: Maybe<Array<StorageProductRelationProxy>>;
  units?: Maybe<Array<UnitProxy>>;
};


export type UnitGroupProxyAlternativeProductsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type UnitGroupProxyProductsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type UnitGroupProxyStorageProductRelationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type UnitGroupProxyUnitsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UnitProxy = {
  __typename?: 'UnitProxy';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  unitGroup?: Maybe<UnitGroupProxy>;
  unitOrder?: Maybe<Scalars['Int']['output']>;
};

export type UserBranchRelationProxy = {
  __typename?: 'UserBranchRelationProxy';
  branch: BranchProxy;
  employee: EmployeeProxy;
  id: Scalars['Int']['output'];
  role: RoleProxy;
};

export type UserCompanyRelationProxy = {
  __typename?: 'UserCompanyRelationProxy';
  company?: Maybe<CompanyProxy>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  role?: Maybe<RoleProxy>;
};

export type UserProxy = {
  __typename?: 'UserProxy';
  companies?: Maybe<Array<CompanyProxy>>;
  company?: Maybe<CompanyProxy>;
  currentBranch?: Maybe<BranchProxy>;
  email?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  isUserActiveWithinTariff?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RoleProxy>;
  roles: Array<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};


export type UserProxyCompanyArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};


export type UserProxyEmployeeArgs = {
  companyId: Scalars['Int']['input'];
};


export type UserProxyIsUserActiveWithinTariffArgs = {
  companyId: Scalars['Int']['input'];
};


export type UserProxyNameArgs = {
  companyId: Scalars['Int']['input'];
};


export type UserProxyRoleArgs = {
  companyId: Scalars['Int']['input'];
};


export type UserProxySurnameArgs = {
  companyId: Scalars['Int']['input'];
};

export type VacationProxy = {
  __typename?: 'VacationProxy';
  employee?: Maybe<EmployeeProxy>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<VacationType>;
};


export type VacationProxyEndDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type VacationProxyStartDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export enum VacationType {
  Absenteeism = 'ABSENTEEISM',
  Holiday = 'HOLIDAY',
  PaidDayOff = 'PAID_DAY_OFF',
  SickLeave = 'SICK_LEAVE',
  UnpaidDayOff = 'UNPAID_DAY_OFF'
}

export type WorkScheduleProxy = {
  __typename?: 'WorkScheduleProxy';
  branch?: Maybe<BranchProxy>;
  editUrl?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  employeeLogbookUrl?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  offDays?: Maybe<Array<OffDayProxy>>;
  startDate: Scalars['String']['output'];
  workingDayPeriods: Array<Maybe<WorkingDayPeriodProxy>>;
};


export type WorkScheduleProxyEndDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type WorkScheduleProxyOffDaysArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type WorkScheduleProxyStartDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type WorkScheduleProxyWorkingDayPeriodsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkingDayPeriodProxy = {
  __typename?: 'WorkingDayPeriodProxy';
  day?: Maybe<DayProxy>;
  endTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
  workSchedule?: Maybe<WorkScheduleProxy>;
};


export type WorkingDayPeriodProxyEndTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type WorkingDayPeriodProxyStartTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type WriteOffReasonProxy = {
  __typename?: 'WriteOffReasonProxy';
  company?: Maybe<CompanyProxy>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  storageProductRelationHistories?: Maybe<Array<StorageProductRelationHistoryProxy>>;
};


export type WriteOffReasonProxyStorageProductRelationHistoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BookingRestaurantMutation = {
  __typename?: 'bookingRestaurantMutation';
  createCustomReservation: ReservationProxy;
  createReservation: ReservationProxy;
  createReservationSource: Scalars['Boolean']['output'];
  createRestaurantAddRequest: Scalars['Boolean']['output'];
  createRestaurantDeleteRequest: Scalars['Boolean']['output'];
  createReview: RestaurantReviewProxy;
  deleteReview: Scalars['Boolean']['output'];
  deleteReviewPhoto: Scalars['Boolean']['output'];
  markUserReservationsAsPremium: Scalars['Boolean']['output'];
  reservationChangeStatus: ReservationProxy;
  restaurantAddRequestChangeStatus: RestaurantAddRequestProxy;
  restaurantAddRequestSetInternalNote: RestaurantAddRequestProxy;
  restaurantDeleteRequestChangeStatus: RestaurantDeleteRequestProxy;
  restaurantDeleteRequestSetInternalNote: RestaurantDeleteRequestProxy;
  updateReservation: ReservationProxy;
  updateReview: RestaurantReviewProxy;
};


export type BookingRestaurantMutationCreateCustomReservationArgs = {
  input: CustomReservationInput;
};


export type BookingRestaurantMutationCreateReservationArgs = {
  input: ReservationInput;
};


export type BookingRestaurantMutationCreateReservationSourceArgs = {
  input: ReservationSourceInput;
};


export type BookingRestaurantMutationCreateRestaurantAddRequestArgs = {
  input: RestaurantAddRequestInput;
};


export type BookingRestaurantMutationCreateRestaurantDeleteRequestArgs = {
  input: RestaurantDeleteRequestInput;
};


export type BookingRestaurantMutationCreateReviewArgs = {
  branchId: Scalars['Int']['input'];
  input: RestaurantReviewInput;
};


export type BookingRestaurantMutationDeleteReviewArgs = {
  reviewUuid: Scalars['Uuid']['input'];
  userUuid: Scalars['Uuid']['input'];
};


export type BookingRestaurantMutationDeleteReviewPhotoArgs = {
  photoId: Scalars['Int']['input'];
  reviewUuid: Scalars['Uuid']['input'];
  userUuid: Scalars['Uuid']['input'];
};


export type BookingRestaurantMutationMarkUserReservationsAsPremiumArgs = {
  userUuid: Scalars['Uuid']['input'];
};


export type BookingRestaurantMutationReservationChangeStatusArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  status: ReservationStatus;
  uuid: Scalars['Uuid']['input'];
};


export type BookingRestaurantMutationRestaurantAddRequestChangeStatusArgs = {
  id: Scalars['Int']['input'];
  status: RestaurantAddRequestStatus;
};


export type BookingRestaurantMutationRestaurantAddRequestSetInternalNoteArgs = {
  id: Scalars['Int']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
};


export type BookingRestaurantMutationRestaurantDeleteRequestChangeStatusArgs = {
  id: Scalars['Int']['input'];
  status: RestaurantDeleteRequestStatus;
};


export type BookingRestaurantMutationRestaurantDeleteRequestSetInternalNoteArgs = {
  id: Scalars['Int']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
};


export type BookingRestaurantMutationUpdateReservationArgs = {
  input: ReservationUpdateInput;
  uuid: Scalars['Uuid']['input'];
};


export type BookingRestaurantMutationUpdateReviewArgs = {
  input: RestaurantReviewInput;
  uuid: Scalars['Uuid']['input'];
};

export type BookingRestaurantQuery = {
  __typename?: 'bookingRestaurantQuery';
  branchRating?: Maybe<RestaurantRating>;
  branchReviews?: Maybe<RestaurantReviewPaginated>;
  reservation?: Maybe<ReservationProxy>;
  reservationById?: Maybe<ReservationProxy>;
  reservations?: Maybe<ReservationPaginated>;
  restaurantAddRequest?: Maybe<RestaurantAddRequestProxy>;
  restaurantAddRequests?: Maybe<RestaurantAddRequestPaginated>;
  restaurantDeleteRequest?: Maybe<RestaurantDeleteRequestProxy>;
  restaurantDeleteRequests?: Maybe<RestaurantDeleteRequestPaginated>;
  review?: Maybe<RestaurantReviewProxy>;
  userReservations?: Maybe<ReservationPaginated>;
  userReviews?: Maybe<RestaurantReviewPaginated>;
};


export type BookingRestaurantQueryBranchRatingArgs = {
  branchId: Scalars['Int']['input'];
};


export type BookingRestaurantQueryBranchReviewsArgs = {
  branchId: Scalars['Int']['input'];
  order?: InputMaybe<Order>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchBranchName?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<RestaurantReviewSortField>;
};


export type BookingRestaurantQueryReservationArgs = {
  uuid: Scalars['Uuid']['input'];
};


export type BookingRestaurantQueryReservationByIdArgs = {
  id: Scalars['Int']['input'];
};


export type BookingRestaurantQueryReservationsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ReservationSortInput>>;
  statuses?: InputMaybe<Array<ReservationStatus>>;
};


export type BookingRestaurantQueryRestaurantAddRequestArgs = {
  id: Scalars['Int']['input'];
};


export type BookingRestaurantQueryRestaurantAddRequestsArgs = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<RestaurantRequestSortInput>>;
  statuses?: InputMaybe<Array<RestaurantAddRequestStatus>>;
};


export type BookingRestaurantQueryRestaurantDeleteRequestArgs = {
  id: Scalars['Int']['input'];
};


export type BookingRestaurantQueryRestaurantDeleteRequestsArgs = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<RestaurantRequestSortInput>>;
  statuses?: InputMaybe<Array<RestaurantDeleteRequestStatus>>;
};


export type BookingRestaurantQueryReviewArgs = {
  uuid: Scalars['Uuid']['input'];
};


export type BookingRestaurantQueryUserReservationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchBranchName?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ReservationSortInput>>;
  statuses?: InputMaybe<Array<ReservationStatus>>;
  userUuid: Scalars['Uuid']['input'];
};


export type BookingRestaurantQueryUserReviewsArgs = {
  order?: InputMaybe<Order>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchBranchName?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<RestaurantReviewSortField>;
  userUuid: Scalars['Uuid']['input'];
};
